module.exports = __webpack_public_path__ + "static/media/whyEngageImage.da4877ed.png";